import * as React from 'react';
// tslint:disable:max-line-length

class SecurePaymentSvg extends React.Component {
  public renderSvg = () => {
    return (
        <svg id="icon-secure" data-name="Icon Secure" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 83.3 40.35">
          <title>Secure</title>
          <path className="ico-4"
                d="M39.32,16.06a3.49,3.49,0,0,0,1.76.5,1.36,1.36,0,0,0,1.59-1.3c0-.71-0.41-1.12-1.43-1.51-1.24-.44-2-1.08-2-2.15a2.19,2.19,0,0,1,2.46-2.06,3.46,3.46,0,0,1,1.68.37l-0.27.8a3,3,0,0,0-1.44-.36,1.23,1.23,0,0,0-1.43,1.14c0,0.71.46,1.06,1.51,1.47,1.29,0.5,1.94,1.12,1.94,2.23s-0.87,2.2-2.66,2.2a3.92,3.92,0,0,1-1.94-.5Z"/>
          <path className="ico-4" d="M49,13.7H46v2.74h3.29v0.82H45V9.66h4.11v0.82H46v2.4h3V13.7Z"/>
          <path className="ico-4"
                d="M55.88,17a4.83,4.83,0,0,1-2,.37,3.56,3.56,0,0,1-3.76-3.86,3.78,3.78,0,0,1,4-4,4.07,4.07,0,0,1,1.8.34l-0.24.8a3.57,3.57,0,0,0-1.53-.32,2.83,2.83,0,0,0-3,3.14,2.76,2.76,0,0,0,2.92,3.06,3.93,3.93,0,0,0,1.6-.32Z"/>
          <path className="ico-4"
                d="M58.09,9.66v4.5c0,1.7.76,2.43,1.77,2.43s1.85-.74,1.85-2.43V9.66h1v4.43c0,2.33-1.23,3.29-2.88,3.29s-2.73-.89-2.73-3.25V9.66h1Z"/>
          <path className="ico-4"
                d="M64.4,9.76a10.25,10.25,0,0,1,1.88-.16,3.1,3.1,0,0,1,2.2.62,1.89,1.89,0,0,1,.6,1.44,2,2,0,0,1-1.43,1.94v0a1.89,1.89,0,0,1,1.12,1.53,12.22,12.22,0,0,0,.59,2.09h-1a10.16,10.16,0,0,1-.51-1.82A1.48,1.48,0,0,0,66.31,14H65.39v3.29h-1V9.76Zm1,3.46h1a1.5,1.5,0,0,0,1.72-1.44c0-1-.71-1.41-1.75-1.42a4,4,0,0,0-1,.09v2.78Z"/>
          <path className="ico-4" d="M74.41,13.7h-3v2.74h3.29v0.82H70.47V9.66h4.11v0.82H71.45v2.4h3V13.7Z"/>
          <path className="ico-4"
                d="M36.59,22.48a11.42,11.42,0,0,1,1.88-.15A3.12,3.12,0,0,1,40.6,23a2,2,0,0,1,.67,1.59,2.24,2.24,0,0,1-.59,1.62,3.15,3.15,0,0,1-2.32.83A3.35,3.35,0,0,1,37.57,27v3h-1V22.48Zm1,3.67a3.31,3.31,0,0,0,.81.08,1.62,1.62,0,0,0,1.91-1.62c0-1-.71-1.49-1.79-1.49a4.12,4.12,0,0,0-.93.08v3Z"/>
          <path className="ico-4"
                d="M42.87,27.6L42.08,30h-1l2.58-7.6h1.18L47.43,30h-1L45.57,27.6h-2.7Zm2.49-.77-0.74-2.19c-0.17-.5-0.28-0.95-0.39-1.39h0c-0.11.45-.24,0.91-0.38,1.38l-0.74,2.2h2.29Z"/>
          <path className="ico-4"
                d="M49.34,30V26.77l-2.4-4.38h1.12l1.07,2.1c0.29,0.57.52,1,.76,1.57h0c0.21-.5.47-1,0.77-1.57l1.09-2.1h1.12l-2.55,4.37V30h-1Z"/>
          <path className="ico-4"
                d="M60,26.66c-0.06-1.06-.12-2.34-0.11-3.28h0c-0.26.89-.58,1.85-1,2.89L57.6,30H56.86l-1.23-3.62c-0.36-1.07-.67-2.05-0.88-3h0c0,0.95-.08,2.22-0.15,3.36L54.37,30H53.44L54,22.39h1.25l1.3,3.68c0.32,0.94.58,1.77,0.77,2.56h0c0.19-.77.46-1.6,0.8-2.56l1.35-3.68h1.25L61.2,30h-1Z"/>
          <path className="ico-4" d="M66.65,26.43h-3v2.74H67V30H62.71v-7.6h4.11v0.82H63.69v2.4h3v0.81Z"/>
          <path className="ico-4"
                d="M68.26,30v-7.6h1.07l2.44,3.85a21.27,21.27,0,0,1,1.37,2.47h0c-0.09-1-.11-1.94-0.11-3.12V22.39H74V30H73l-2.41-3.86a23.91,23.91,0,0,1-1.42-2.54h0c0.06,1,.08,1.87.08,3.14V30H68.26Z"/>
          <path className="ico-4" d="M77.12,23.23H74.81V22.39h5.63v0.83H78.11V30h-1V23.23Z"/>
          <path className="ico-4"
                d="M22.58,12.05l-2.3-7.57a5.13,5.13,0,0,0-6.39-3.42L4.81,3.81a5.13,5.13,0,0,0-3.42,6.39l2.3,7.57a6.34,6.34,0,0,0-.83,5.42L6.27,34.46A6.36,6.36,0,0,0,14.2,38.7l11.26-3.41a6.36,6.36,0,0,0,4.24-7.93L26.28,16.1A6.34,6.34,0,0,0,22.58,12.05ZM21.09,31.63L15.7,33.26l-0.24-9.05A2.82,2.82,0,1,1,16.26,24Zm-2.6-19.8-0.14,0L7.1,15.27,7,15.32,5.07,9.09a1.28,1.28,0,0,1,.85-1.6L15,4.74a1.28,1.28,0,0,1,1.6.85Z"/>
        </svg>
    );
  }

  public render() {
    return(
      <div>
        {this.renderSvg()}
      </div>
    );
  }
}

export default SecurePaymentSvg;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/QuoteSidebar/components/SecurePaymentSvg/SecurePaymentSvg.tsx